<template>
  <div class="flex items-start gap-20 lg:gap-40">
    <div ref="column1" class="flex flex-col flex-1">
      <div v-for="(artwork1, artwork1Index) in columns.column1" :key=artwork1Index>
        <slot :artwork="artwork1"></slot>
      </div>
    </div>

    <div ref="column2" class="flex flex-col flex-1">
      <div v-for="(artwork2, artwork2Index) in columns.column2" :key=artwork2Index>
        <slot :artwork="artwork2"></slot>
      </div>
    </div>

    <div ref="column3" class="flex flex-col flex-1">
      <div v-for="(artwork3, artwork3Index) in columns.column3" :key=artwork3Index>
        <slot :artwork="artwork3"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    artworks: { required: true, type: Array }
  },

  data () {
    return {
      columns: {
        column1: [],
        column2: [],
        column3: [],
      }
    }
  },

  methods: {
    async setList(artworks) {
      let i = 0
      while (i < artworks.length) {
        this.shortestColumn().push(artworks[i])
        i++
        await this.$nextTick()
      }
    },

    shortestColumn() {
      return this.columns[this.shortest(this.$refs.column1, this.$refs.column2, this.$refs.column3)]
    },

    shortest(column1, column2, column3) {
      let shortestHeight = Math.min(
        column1.getBoundingClientRect().height,
        column2.getBoundingClientRect().height,
        column3.getBoundingClientRect().height
      )

      if (column1.getBoundingClientRect().height === shortestHeight) {
        return 'column1'
      } else if (column2.getBoundingClientRect().height === shortestHeight) {
        return 'column2'
      } else if (column3.getBoundingClientRect().height === shortestHeight) {
        return 'column3'
      }
    }
  },

  mounted () {
    this.setList(this.artworks)
  }
}
</script>
